// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle-right[data-v-21b0b9fc]{top:90px}.circle-left[data-v-21b0b9fc]{left:-8%;top:25%}.content-container[data-v-21b0b9fc]{margin-top:-150px}.content-container .main-content[data-v-21b0b9fc]{-moz-column-count:1;column-count:1}@media (min-width:1024px){.content-container .main-content[data-v-21b0b9fc]{-moz-column-count:2;column-count:2;grid-column-gap:1rem;-moz-column-gap:1rem;column-gap:1rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
